// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1nUBr","actionsCol":"EnrolledClinics_actionsCol__3gzm5"};